import BlogsList from './BlogsList'
import react from 'react'
import "./../../CSS/Blogs.css"
import Wrapper from './../../Components/Common/Loading/Wrapper'
function Blogs(){
    return(
<div className="container blogsWrapper">
    <h2>In Progress</h2>

    <Wrapper></Wrapper>
</div>
    )
}
export default Blogs;